/**
 * Desktop platform shell adapter — thin wrapper that delegates to the canonical
 * shared shell at `@shared/platform/PlatformShell`. Keeps the legacy
 * `{ className, children }` prop shape so existing consumers compile
 * unchanged, while the actual shell rendering (NP gradient mark, app chip,
 * theme toggle pill, notifications, settings menu, avatar) comes from the
 * shared module per spec 015-chat-widget-polish and mockup
 * `tmp/platform-mockups/platform-shell.html`.
 */
import { PlatformShell as SharedPlatformShell } from '@shared/platform';
import { useAuthStore } from '@/stores/authStore';
import { useAuth } from '@/hooks/useAuth';

interface PlatformShellProps {
  className?: string;
  children?: React.ReactNode;
}

export default function PlatformShell({ children }: PlatformShellProps) {
  const { user } = useAuthStore();
  const { logout } = useAuth();

  return (
    <SharedPlatformShell
      variant="desktop"
      user={{
        email: user?.email ?? null,
        username: user?.username ?? null,
        is_admin: user?.is_admin ?? false,
      }}
      onLogout={() => logout()}
    >
      {children}
    </SharedPlatformShell>
  );
}
